/* @ngInject */
const saleFields = (
  saleLabels,
  icons,
  types
) => {
  const self = {}

  self.id = {
    ref: 'id',
    label: saleLabels.fields.id.text,
    output: {
      sortable: true,
      table: false,
      details: false,
      excel: false,
    },
  }

  self.number = {
    ref: 'number',
    label: saleLabels.fields.number.text,
    icon: icons.sale.number,
    type: types.text(),
    required: true,
    unique: true,
    nature: 'sale',
    messages: saleLabels.fields.number.messages,
    output: {
      sortable: true,
      table: { prefill: true, },
      details: true,
      excel: { prefill: false, },
    },
  }

  self.ownerId = {
    ref: 'ownerId',
    label: saleLabels.fields.owner.text,
    choice: saleLabels.fields.owner.choice,
    type: 'select',
    options: 'owner.id as owner.society for owner',
    order: 'society.toString()',
    output: {
      sortable: true,
      table: false,
      details: false,
      excel: false,
    },
  }

  self.owner = {
    ref: 'owner',
    label: saleLabels.fields.owner.text,
    output: {
      sortable: true,
      table: { prefill: true, },
      details: true,
      excel: { prefill: false, },
    },
  }

  self.date = {
    ref: 'date',
    label: saleLabels.fields.date.text,
    icon: icons.date,
    type: types.date,
    output: {
      sortable: true,
      table: { prefill: true, },
      details: true,
      excel: { prefill: false, },
    },
  }

  self.axletreeDefaultWeight = {
    ref: 'axletreeDefaultWeight',
    label: saleLabels.fields.axletreeDefaultWeight.text,
    icon: icons.weight,
    type: types.decimal,
    output: {
      sortable: false,
      table: { prefill: false, },
      details: false,
      excel: { prefill: false, },
    },
  }

  self.dateBegin = {
    ref: 'dateBegin',
    label: saleLabels.fields.dateBegin.text,
    icon: icons.date,
    type: types.date,
    output: {
      sortable: true,
      table: false,
      details: false,
      excel: false,
    },
  }

  self.dateEnd = {
    ref: 'dateEnd',
    label: saleLabels.fields.dateEnd.text,
    icon: icons.date,
    type: types.date,
    output: {
      sortable: true,
      table: false,
      details: false,
      excel: false,
    },
  }

  self.axletree = {
    ref: 'axletree',
    label: 'Numéro d\'essieu',
    icon: icons.sale.train,
    type: types.text(),
  }
  self.piece = {
    ref: 'piece',
    label: 'Nom de pièce',
    icon: icons.sale.train,
    type: types.text(),
  }
  self.sterile = {
    ref: 'sterile',
    label: 'Nom de stérile',
    icon: icons.sale.train,
    type: types.text(),
  }

  return self
}
export default saleFields



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/sale/resources/fields.resource.js